import React from 'react';
import { BookOpenIcon, ClipboardCheckIcon, EyeIcon, GiftIcon, PenLineIcon, PresentationIcon, SearchIcon, ZapIcon } from 'lucide-react';
import { CtaBlock } from '../CtaButton';
import { SectionHeading } from './SectionHeading';
import { AssuranceRow } from './AssuranceRow';
import { offerIncludes } from '../../data/content';
import { MOCKUP_URL } from '../../data/images';
const icons = [BookOpenIcon, GiftIcon, EyeIcon, PenLineIcon, SearchIcon, ClipboardCheckIcon, PresentationIcon, ZapIcon];

/** The value stack — the only block with the price and the real checkout button. */
export function OfferSection() {
  return <section id="offer" aria-labelledby="offer-heading" className="scroll-mt-4 bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-24" data-id="element-128" data-mp="23gxive8dspl0">
      <div className="mx-auto max-w-5xl" data-id="element-129" data-mp="2vyjdphxsjbjs">
        <SectionHeading id="offer-heading" title="Tout votre système Ready-to-Teach en un seul endroit." data-id="element-130" data-mp="2w0cjyw4hrtr9" />

        <div className="mx-auto mt-12 max-w-4xl overflow-hidden rounded-[28px] border-2 border-brand-gold/50 bg-white shadow-[0_50px_100px_-50px_rgba(120,96,56,0.55)]" data-id="element-131" data-mp="2r6rtrq95442m">
          <div className="bg-brand-forest px-6 py-4 text-center" data-id="element-132" data-mp="3hftjh51z8exv">
            <p className="font-body text-[12px] font-bold uppercase tracking-[0.2em] text-brand-ivory" data-id="element-133" data-mp="33pq48y1illhx">
              Nail Educator Ready™ — Édition Française
            </p>
          </div>

          <div className="px-6 py-10 sm:px-12" data-id="element-134" data-mp="2trab6pixg25s">
            <img src={MOCKUP_URL} alt="Tout ce qui est inclus dans Nail Educator Ready" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto block w-full max-w-[580px] object-contain" style={{
            filter: 'drop-shadow(0 24px 28px rgba(120, 96, 56, 0.2))'
          }} data-id="element-135" data-mp="2tqisgfafhywx" />

            <ul className="mx-auto mt-10 grid max-w-2xl gap-x-8 gap-y-3.5 sm:grid-cols-2" role="list" data-id="element-136" data-mp="j0k65yeq6i1o">
              {offerIncludes.map((item, index) => {
              const Icon = icons[index];
              return <li key={item} className="flex items-center gap-3 text-[15px] leading-snug text-brand-charcoal sm:text-[16px]" data-id="element-137" data-mp="1vvoilput08vw" data-mpi={index}>
                    <Icon className="h-4 w-4 flex-none text-brand-cta" strokeWidth={2} aria-hidden="true" data-id="element-138" data-mp="1mwtfimn23ewt" />
                    {item}
                  </li>;
            })}
            </ul>

            <div className="mt-10 border-t border-brand-charcoal/10 pt-9" data-id="element-139" data-mp="2eose7grl0vt5">
              <CtaBlock label="Obtenir mon accès immédiat" showPrice data-id="element-140" data-mp="2amnnapsiqda7" />
              <AssuranceRow className="mt-5" data-id="element-141" data-mp="2angwdxey9evi" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}